import axios from '@/plugins/axios';

export async function exportReadyCheck(uuid){
    return await axios.get(`notifications/export-ready/check/${uuid}`);
}

export async function exportReadyDownload(uuid){
    return await axios.get(`notifications/export-ready/download/${uuid}`, {responseType: 'blob'});
}
